import React from 'react';
import { DataTable } from 'pepsico-ds';
import type { IDataTableProps } from 'pepsico-ds/dist/lib/Organisms/DataTable/types';
import styled from 'styled-components';

// Create a styled wrapper to handle conditional pagination display
const StyledDataTableWrapper = styled.div<{ hidePagination?: boolean }>`
  ${(props) =>
    props.hidePagination
      ? `
        #pagination {
          display: none !important;
        }
      `
      : ''}

  .datatable {
    width: auto !important;
  }

  .selected-items-container {
    display: none !important;
  }

  /* Thin scrollbar styling */
  * {
    scrollbar-width: thin;
    scrollbar-color: #616161 transparent;
  }

  *::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  *::-webkit-scrollbar-track {
    background: #616161;
  }
`;

interface DataTableWrapperProps<T extends object>
  extends Omit<IDataTableProps<T>, 'rowSelectionStateUpdater'> {
  enableSingleSelect?: boolean;
  hidePagination?: boolean;
}

const DataTableWrapper = <T extends object>({
  data,
  columns,
  filters,
  pageIndex = 0,
  pageSize = 10,
  isExpandable = false,
  selection = 'single',
  enableSorting = true,
  tableHeader = '',
  tableDescription,
  toolbarActions,
  // onUpdate,
  hidePagination = false,
  ...rest
}: DataTableWrapperProps<T>) => {
  // Adjust pageSize to match data length when hidePagination is true to ensure only one page
  const adjustedPageSize =
    hidePagination && data?.length ? data.length : pageSize;

  return (
    <StyledDataTableWrapper hidePagination={hidePagination}>
      <DataTable
        data={data}
        columns={columns}
        filters={filters}
        isExpandable={isExpandable}
        pageIndex={pageIndex}
        pageSize={adjustedPageSize}
        selection={selection}
        enableSorting={enableSorting}
        tableHeader={tableHeader}
        tableDescription={tableDescription}
        toolbarActions={toolbarActions}
        showFilterButton={false}
        showSearchOption={false}
        showMultiSortMenu={false}
        // onUpdate={onUpdate}
        {...rest}
      />
    </StyledDataTableWrapper>
  );
};

export default DataTableWrapper;
